import { Deserializable } from '../protocols/deserializable';
import * as moment from 'moment';

export class PersonalInfoSubmission implements Deserializable {
  public previous!: PersonalInfoSubmissionDetails;
  public new!: PersonalInfoSubmissionDetails;

  onDeserialize(): void {
    const deserialize = window?.injector?.Deserialize;

    if (!!this.previous) {
      this.previous = deserialize?.instanceOf(PersonalInfoSubmissionDetails, this.previous);
    }

    if (!!this.new) {
      this.new = deserialize?.instanceOf(PersonalInfoSubmissionDetails, this.new);
    }
  }
}

export class PersonalInfoSubmissionDetails implements Deserializable {
  public birthDate!: string;
  public gender!: string;
  public genderId!: number;
  public pronoun!: string;
  public pronounId!: number;
  public socialInsuranceNumber!: string;

  // Not from API
  public formattedBirthDate!: string;
  public formattedSIN!: string;

  onDeserialize(): void {
    if (!!this.birthDate) {
      this.formattedBirthDate = moment(this.birthDate.split('T')[0]).format('DD / MM / YYYY');
    }

    if (!!this.socialInsuranceNumber) {
      this.formattedSIN = this.socialInsuranceNumber.replace(/(\d{3})(\d{3})(\d{3})/, '*** $2 $3');
    }
  }
}
